import { SearchOutlined } from "@ant-design/icons";
import { Input, Space, Table, message } from "antd";
import { ColumnType } from "antd/es/table";
import { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";

import StringUtils from "../../util/StringUtils";
import ProductApi from "../../api/ProductApi";
import { ProductManagementWrapper, TableWrapper, ToolBarLeftWrapper, ToolBarRightWrapper, ToolBarWrapper } from "./ProductManagement.styled";
import ProductDetails from "./product-details/ProductDetails";

interface ProductManagementProps {

}

const ProductManagement: React.FC<ProductManagementProps> = (props)=> {
    // api
    let productApi = new ProductApi();
    const [messageApi, contextHolder] = message.useMessage();
    let navigate = useNavigate();

    // state
    let [loading, setLoading] = useState(true);
    let [products, setProducts] = useState([]);
    let [searchValue, setSearchValue] = useState("");

    // events
    let onViewProduct = (product: any)=> {
        navigate(`/product-management/product/${product.id}`)
    };

    let onInputChange = (e)=> {
        setSearchValue(e.target.value);
    };

    // load product views
    let loadProductViews = async ()=> {
        setLoading(true);
        let products = (await productApi.getAll()).data.data;
        products.forEach((e)=> { e.specification = JSON.parse(e.specification); });
        setProducts(products);
        setLoading(false);
    }

    // column definition
    let columns: ColumnType<any>[] = [
        {
            title: '产品名称',
            dataIndex: 'product.name',
            key: 'product.name',
            align: 'center',
            render: (text, record, index)=> {
                return <a onClick={()=> onViewProduct(record)}>{record.name}</a>
            }
        },
        {
            title: '产品型号',
            dataIndex: 'product.modelName',
            key: 'product.modelName',
            align: 'center',
            render: (text, record, index)=> {
                return <span>{record.modelName || record.model}</span>
            }
        },
        {
            title: '网络制式',
            dataIndex: 'product.specification.basic.mobileNetwork?.networkStandard',
            key: 'product.specification.basic.mobileNetwork?.networkStandard',
            align: 'center',
            render: (text, record, index)=> {
                return <span>{record.specification.basic.mobileNetwork?.networkStandard}</span>
            }
        },
        {
            title: 'GNSS定位',
            dataIndex: 'product.specification.gnss?.supportedGnss',
            key: 'product.specification.gnss?.supportedGnss',
            align: 'center',
            render: (text, record, index)=> {
                return <span>{record.specification.basic.gnss?.supportedGnss}</span>
            }
        },
        {
            title: '备注',
            dataIndex: 'product.remarks',
            key: 'product.remarks',
            align: 'center',
            render: (text, record, index)=> {
                return <span>{StringUtils.emptyToSlash(record.remarks)}</span>
            }
        },
        {
            title: '操作',
            key: 'action',
            align: 'center',
            render: (text, record, index)=> {
                return <Space size="middle">
                    <a onClick={()=> onViewProduct(record)}>查看详情</a>
                </Space>
            }
        }
    ];

    let filteredProducts = [].concat(products);
    if (searchValue) {
        filteredProducts = filteredProducts.filter((e)=> {
            if (e.name.indexOf(searchValue)>=0 
            || e.model.indexOf(searchValue)>=0) {
                return true;
            }
            return false;
        });
    }

    // effect
    useEffect(()=> {
        loadProductViews();
    }, []);
    
    // render
    return (
        <ProductManagementWrapper>
            {contextHolder}
            <ToolBarWrapper>
                <ToolBarLeftWrapper>
                </ToolBarLeftWrapper>

                <ToolBarRightWrapper>
                    <Input 
                        placeholder="请输入产品名称" 
                        suffix={<SearchOutlined />} 
                        size="middle" 
                        onChange={onInputChange} />
                </ToolBarRightWrapper>
            </ToolBarWrapper>
            <TableWrapper>
                <Table 
                    rowKey={(record)=> record.id}
                    columns={columns} 
                    dataSource={filteredProducts}
                    loading={loading}
                />
            </TableWrapper>

            <Routes>
                <Route path="product/:productId" element={<ProductDetails onClose={()=>{}} onComplete={()=>{}}/>} />
            </Routes>
        </ProductManagementWrapper>
    );
}

export default ProductManagement;
